export enum TitleOptionEnum {
  origin = "Elige tu cuenta origen",
  originFrom = "Desde tu cuenta",
  amount = "Seleccionar monto",
  confirm = "Confirmación",
  off = '',
  schedule = 'Recarga programada',
  scheduleConfirm = 'scheduleConfirm'
}
